import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { styled } from '../components/styled';
import SpButton from '../components/atoms/SpButton';
import SpTextInput from '../components/atoms/SpTextInput';
import SpText from '../components/atoms/SpText';
import SpDialog from '../components/atoms/SpDialog';
import { theme } from '../components/theme';
import { changePassword, logoutUser, loginUser, registerUser } from '../models/actions/Auth';
import { labels } from '../pages/shared/translations';
import { Grid } from '@material-ui/core';
import { withSnackbar } from '../components/atoms/SpSnackBar';
import SpLoadingButton from '../components/atoms/SpLoadingButton';
import { logo_url_dev, piedino_asobike } from '../config';
import { UserSessionContext } from '../App';

const StyledRowDialog = styled('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '4%'
});

const StyledColumnLogin = styled(Grid)({
  alignSelf: 'center',
  padding: '2%',
  marginTop: 20,
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: '40%',
  border: '1px solid #4DAC27',
  borderRadius: 20,
  color: '#4DAC27',
  borderColor: '#4DAC27',
  backgroundColor: '#FFF',
  boxShadow: ` 5px 5px 10px ${theme.colors.mainGreen.secondary} `
});

const StyledColumn = styled('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  alignItems: 'center',
  padding: '2%'
});

const Login = (props) => {
  const [open, setOpen] = useState(false);
  const [emailForgotPassword, setEmailForgot] = useState(null);
  const [inputError, setInputError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const { control, register, handleSubmit, errors, reset } = useForm({
    shouldUnregister: false,
    name: 'user'
  });
  const history = useHistory();
  const { authData, setAuthData } = useContext(UserSessionContext);

  const callLoginUser = async (data) => {
    setIsLoading(true);
    try {
      const response = await loginUser(data);
      if (response.status != 200) {
        if (response.status == 401 || response.status == 404) props.snackbarShowErrorMessage(response.data.message);
        //setInputError(response.data.message);
      } else {
        setInputError(null);
        props.snackbarShowMessage(response.message);

        if (response.data.type == 'ADMIN') {
          props.setUserType('ADMIN');
          setAuthData({ accessToken: response.data.token, userId: response.data.id });
          history.push({ pathname: '/admin', state: { accessToken: response.data.token, userId: response.data.id } });
        } else {
          props.setUserType(null);
          setAuthData({ accessToken: response.data.token, userId: response.data.id });
          history.push({ pathname: '/', state: { accessToken: response.data.token, userId: response.data.id } });
        }
      }
    } catch (err) {
      props.snackbarShowErrorMessage(err);
    }
    setIsLoading(false);
  };

  const sendForgotPassEmail = async () => {
    const response = await changePassword(emailForgotPassword);
    if (response.status !== 200) {
      setInputError(response.data.message);
    } else {
      return setOpen(false);
    }
  };

  return (
    <>
      <div style={{ maxWidth: '100%', display: 'flex', justifyContent: 'center' }}>
        <img
          style={{ maxHeight: '150px' }}
          src={piedino_asobike}
        />
      </div>
      <form onSubmit={handleSubmit(callLoginUser)}>
        <StyledColumnLogin
          container
          spacing={2}
          direction="column"
          alignItems="center"
        >
          <Grid
            item
            xs={10}
            style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
          >
            <img
              style={{ width: 'auto', height: '200px' }}
              src={logo_url_dev}
            />
          </Grid>

          <Grid
            item
            xs={6}
            container
            direction="column"
          >
            <SpTextInput
              variant="column"
              name="email"
              inputRef={register({ required: true })}
              label={labels.login.email.toUpperCase()}
            />
            {errors.email && <SpText variant="inputError">{labels.login.emailRequired}</SpText>}
            <SpTextInput
              variant="column"
              name="password"
              inputRef={register({ required: true })}
              type="password"
              label={labels.login.password.toUpperCase()}
            />
            {errors.password && <SpText variant="inputError">{labels.login.passwordRequired}</SpText>}
            {inputError && <SpText variant="inputError">{inputError}</SpText>}
            {/* <SpText style={{ marginLeft: "auto", marginRight: "auto" }} onClick={() => setOpen(true)}>
							{labels.login.passwordLost}
						</SpText> */}
          </Grid>
          <Grid
            item
            xs={6}
            container
            direction="column"
          >
            <SpLoadingButton
              loading={isLoading}
              style={{ marginTop: '3%', marginRight: '0 !important' }}
              text={labels.login.buttons.login}
              buttonType={'accept'}
              variant="none"
              type="submit"
            />
          </Grid>
          <Grid
            item
            xs={8}
          >
            <SpText textAlign={'center'}>
              Effettuando l'accesso accetti <a href="https://www.asobike.com/wp-content/uploads/2025/12/Condizioni-generali.pdf" target="_blank" rel="noopener noreferrer">Termini e Condizioni</a> e <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            </SpText>
          </Grid>
        </StyledColumnLogin>
      </form>
      <SpDialog
        open={open}
        setOpen={setOpen}
        title={labels.login.passwordLostDialog.title}
      >
        <StyledColumn>
          <SpText>{labels.login.passwordLostDialog.subtitle}</SpText>
          <StyledRowDialog>
            <SpTextInput
              name="emailForgotPass"
              value={emailForgotPassword}
              onChange={(e) => setEmailForgot(e.currenTarget.value)}
              label={labels.login.passwordLostDialog.label}
            />
          </StyledRowDialog>
          <StyledRowDialog>
            <SpButton
              onClick={() => sendForgotPassEmail()}
              buttonType="accept"
              text={labels.login.passwordLostDialog.send}
            />
          </StyledRowDialog>
        </StyledColumn>
      </SpDialog>
    </>
  );
};

export default withSnackbar(Login);
